const ACTIONS = {
  CALL_API: "call-api",
  SUCCESS: "success",
  ERROR: "error",
  SET_INITIAL_DATA: "set-data",
  
  TEXT_CHANGE: "text-change",
  TEXT_SET_ERRORS: "text-set-errors",
  TEXT_REMOVE_ERRORS: "text-remove-errors",
  
  DATE_CHANGE: "date-change",
  DATE_SET_ERRORS: "date-set-errors",
  DATE_REMOVE_ERRORS: "date-remove-errors",
  
  RADIO_CHANGE: "radio-change",
  RADIO_SET_ERRORS: "radio-set-errors",
  RADIO_REMOVE_ERRORS: "radio-remove-errors",
};

const MAX_LEN = 500;

const createInitialData = () => ({
  rating: {
    radioButtons: [
      { value: 1, isChecked: false, label: "Like" },
      { value: 0, isChecked: false, label: "Dislike" },
    ],
    selectedValue: null,
    validation: {
      required: true,
      isInvalid: false,
      errors: [],
    },
    disabled: false,
  },
  comment: {
    value: "",
    validation: {
      required: false,
      isInvalid: false,
      errors: [],
    },
    disabled: false,
  },
  submitView: {
    value: "form",
    message: "",
  },
});

const feedbackFormReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_INITIAL_DATA: {
      return {
        ...state,
        data: action.data,
        loading: action.loading,
      };
    }
    
    // ----- TEXT -----
    case ACTIONS.TEXT_CHANGE: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            value: action.value,
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: [],
            },
          },
        },
      };
    }
    case ACTIONS.TEXT_SET_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            validation: {
              ...path.validation,
              isInvalid: action.errors != null ? true : false,
              errors: action.errors,
            },
          },
        },
      };
    }
    case ACTIONS.TEXT_REMOVE_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: [],
            },
          },
          submitView: {
            value: "form",
            message: "",
          },
        },
      };
    }
    
    // ----- DATE -----
    case ACTIONS.DATE_CHANGE:
    case ACTIONS.DATE_SET_ERRORS:
    case ACTIONS.DATE_REMOVE_ERRORS: {
      return state;
    }
    
    // ----- RADIO -----
    case ACTIONS.RADIO_CHANGE: {
      const path = state.data[action.name];
      const newValue = action.value;
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            selectedValue: newValue,
            radioButtons: path.radioButtons.map((btn) => ({
              ...btn,
              isChecked: btn.value === newValue,
            })),
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: [],
            },
          },
        },
      };
    }
    case ACTIONS.RADIO_SET_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            validation: {
              ...path.validation,
              isInvalid: action.errors != null ? true : false,
              errors: action.errors,
            },
          },
        },
      };
    }
    case ACTIONS.RADIO_REMOVE_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: [],
            },
          },
          submitView: {
            value: "form",
            message: "",
          },
        },
      };
    }
    
    // ----- API submission -----
    case ACTIONS.CALL_API: {
      return {
        ...state,
        loading: true,
        apiError: null,
      };
    }
    case ACTIONS.SUCCESS: {
      return {
        ...state,
        loading: false,
        apiError: null,
        apiResponse: action.response,
        data: {
          ...state.data,
          submitView: {
            value: "success",
            message: action.message ?? "Thank you—your feedback helps us improve this page.",
          },
        },
      };
    }
    case ACTIONS.ERROR: {
      return {
        ...state,
        loading: false,
        apiError: action.error,
        data: {
          ...state.data,
          submitView: {
            value: "error",
            message:
              action.message ??
              "We couldn’t submit your feedback. Please try again.",
          },
        },
      };
    }
    default:
      return state;
  }
};

const clearErrorMessages = (dispatch, ACTIONS_CONST) => {
  dispatch({ type: ACTIONS_CONST.TEXT_REMOVE_ERRORS, name: "comment" });
  dispatch({ type: ACTIONS_CONST.RADIO_REMOVE_ERRORS, name: "rating" });
};

const addErrorMessages = (dispatch, ACTIONS_CONST, fieldName, errors) => {
  if (!errors || errors.length === 0) return;
  if (fieldName === "comment") {
    dispatch({ type: ACTIONS_CONST.TEXT_SET_ERRORS, name: "comment", errors });
  } else if (fieldName === "rating") {
    dispatch({ type: ACTIONS_CONST.RADIO_SET_ERRORS, name: "rating", errors });
  }
};

const getFieldValue = (data, fieldName) => {
  switch (fieldName) {
    case "rating": {
      if (data.rating?.selectedValue === 0 || data.rating?.selectedValue === 1) {
        return data.rating.selectedValue;
      }
      const sel = data.rating?.radioButtons?.find((b) => b.isChecked);
      return sel ? sel.value : null;
    }
    case "comment":
      return data.comment?.value ?? "";
    case "sourcePage": {
      return window.location?.pathname ?? "/";
    }
    default:
      return "";
  }
};

export {
  ACTIONS,
  MAX_LEN,
  createInitialData,
  feedbackFormReducer,
  clearErrorMessages,
  addErrorMessages,
  getFieldValue,
};
